import classNames from "classnames"

import * as Scrivito from "scrivito"

import { Hero } from "widgets/hero/Hero"

import { FeatureWidgetView } from "../FeatureWidget/Components/FeatureWidgetView"
import { HeroWidget } from "./HeroWidgetClass"

Scrivito.provideComponent(HeroWidget, ({ widget }) => {
  const version = widget.get("version") || "v1"

  const headline = <Scrivito.ContentTag content={widget} attribute="headline" />
  const text = <Scrivito.ContentTag content={widget} attribute="text" />
  const buttons =
    Scrivito.isInPlaceEditingActive() ||
    (widget.get("buttons")?.length ?? 0) > 0 ? (
      <Scrivito.ContentTag tag="div" content={widget} attribute="buttons" />
    ) : null

  const image = (
    <div className={classNames("image")}>
      <Scrivito.ContentTag content={widget} attribute="imageWidgets" />
    </div>
  )

  if (version === "v2") {
    return (
      <Hero headline={headline} text={text} buttons={buttons} image={image} />
    )
  }

  // v1 rendering (legacy)
  return (
    <FeatureWidgetView
      className="hero hero--v1"
      headline={
        <Scrivito.ContentTag tag="h1" content={widget} attribute="headline" />
      }
      text={text}
      buttons={buttons}
      content={
        <div className={classNames("feature-widget__image")}>
          <Scrivito.ContentTag content={widget} attribute="imageWidgets" />
        </div>
      }
    />
  )
})
